import { BRAND_TYPE } from "@faire/help-center-utils/consts/BRAND_TYPE";
import { OTHER_TYPE } from "@faire/help-center-utils/consts/OTHER_TYPE";
import { RETAILER_TYPE } from "@faire/help-center-utils/consts/RETAILER_TYPE";

import { useLoggedOutContactUsContextStore } from "./LoggedOutContactUsContextStore";

export const useLoggedOutUserType = () => {
  const [{ user }] = useLoggedOutContactUsContextStore(["user"]);

  const isRetailer = user === RETAILER_TYPE;
  const isKnownUserType = user === BRAND_TYPE || user === RETAILER_TYPE;
  const isUnknownUserType = user === OTHER_TYPE;

  return {
    user,
    isRetailer,
    isUnknownUserType,
    isKnownUserType,
  };
};
